import axios from "axios";

const AxiosWeb = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

function resolveTenantSecretKey(tenant) {
  if (!tenant) return null;
  return tenant.publicKey || tenant.secretKey || null;
}

// Request interceptor
AxiosWeb.interceptors.request.use(
  (config) => {
    const raw = localStorage.getItem("selectedTenant");
    const tenant = raw ? JSON.parse(raw) : null;
    const token = localStorage.getItem("accessToken");
    const secretKey = resolveTenantSecretKey(tenant);

    config.headers["Accept"] = "*/*";

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (secretKey) {
      config.headers["X-Tenant-Secret-Key"] = secretKey;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default AxiosWeb;
